import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { RemoteService, InterceptorSkipHeader } from 'app/services/remote.service';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LocalStorageService } from "ngx-store";
import { MatDialog } from '@angular/material/dialog';
import { SessionConfirmationModalComponent, ConfirmDialogModel } from './../session-confirmation-modal/session-confirmation-modal.component';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  requestCount = 0;
  constructor(private router: Router,
    private ls: LocalStorageService,
    public dialog: MatDialog,
    public service: RemoteService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.service.isShowSpinner === true) {
      this.service.showSpinner();
    } else {
      this.service.hideSpinner();
      this.service.isShowSpinner = true;
    }
    let token = this.ls.get('access_token');
    if (request.headers.has(InterceptorSkipHeader)) {
      this.requestCount++;
      const headers = request.headers.delete(InterceptorSkipHeader);
      return next.handle(request.clone({ headers })).pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.requestCount--;
            if (this.requestCount === 0) {
              this.service.hideSpinner();
            }
          }
          return event;
        }),
        catchError((error: HttpErrorResponse) => {
          this.requestCount--;
          this.service.hideSpinner();
          return throwError(error);
        }));;
    } else {
      this.requestCount++;
      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      }
    }
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.requestCount--;
          if (this.requestCount === 0) {
            this.service.hideSpinner();
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.requestCount--;
        this.service.hideSpinner();
        if (error.status === 410) {
          if (this.ls.get('access_token')) {
            if (this.service.sessionIsShow == false) {
              // this.confirmDialog();
              this.ls.clear();
              this.router.navigate(['/login']);
            }
          }
        } else {
          return throwError(error);
        }
      }));
  }

  isJsonError(err) {
    try {
      JSON.parse(err);
    } catch (e) {
      return false;
    }
    return true;
  }

  confirmDialog(): void {
    const data = {
      title: 'Session Expired',
      body: 'Your session has expired',
      isShow: false,
      buttonName: 'Ok'
    }
    const dialogData = new ConfirmDialogModel(data);
    const dialogRef = this.dialog.open(SessionConfirmationModalComponent, {
      maxWidth: "400px",
      data: dialogData,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      this.ls.clear();
      this.router.navigate(['/login']);
    });
  }
}     